export const sensorTypeData = [
    {
        id:    'SA_T', 
        value: 'Supply Air Temperature'
    },
    {
        id:    'DA_Temp', 
        value: 'Supply Air Temperature'
    },
    {
        id:    'Rm Temp', 
        value: 'Supply Air Temperature'
    },
    {
        id:    'RA_T', 
        value: 'Return Air Temperature'
    },
    {
        id:    'SA_P', 
        value: 'Supply Air Pressure'
    },
    {
        id:    'SA_T_STP', 
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'EF_Enable', 
        value: 'Exhaust Fan Command'
    },
    {
        id:    'EF_Status', 
        value: 'Exhaust Fan Status'
    },
    {
        id:    'EF_Speed', 
        value: 'Exhaust Fan Speed'
    },
    {
        id:    'EF_Alarm', 
        value: 'Alarm Status'
    },
    {
        id:    'EF_Fault', 
        value: 'Alarm Status'
    },
    {
        id:    'COMP_STG01_SS', 
        value: 'Compressor 1 Command'
    },
    {
        id:    'COMP_STG02_SS', 
        value: 'Compressor 2 Command'
    },
    {
        id:    'CLG', 
        value: 'Cooling Mode Command'
    },
    {
        id:    'Main_CUP_CHW_plant_inAlarm', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_CHW_plant_supply_temp_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_CW_supply_temp_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_chillers_NOT_running_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_CHWP_NOT_running_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_Chillers_running_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_CHWP_running_ALARM', 
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_01', 
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_02', 
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_03',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_04',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_05',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_CHW_plant_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_NO_chillers_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_NO_CHWPs_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_plant_inAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_6_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_7_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_CWP_NOT_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_CWP_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'spaceTempAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'unOccST_alarmLow',
        value: 'Alarm Status'
    },
    {
        id:    'nvoAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'nvoDischAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'nvoEffectFlowSP',
        value: ' Supply Air Flow Setpoint'
    },
    {
        id:    'nvoEffectOccup',
        value: 'Occupancy Command'
    },
    {
        id:    'nvoEffectSetpt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'nvoSpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: ' Supply Damper Position Command'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'SpaceStaticPressureSetpoint',
        value: 'Space Air Pressure Setpoint'
    },
    {
        id:    'nvoAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'nvoDischAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'nvoEffectFlowSP',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'SpaceStaticPressureSetpoint',
        value: 'Space Air Pressure Setpoint'
    },
    {
        id:    'spaceTempAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'unOccST_alarmLow',
        value: 'Alarm Status'
    },
    {
        id:    'AHU_SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Chiller_6_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_7_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_01',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_02',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_03',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_04',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_05',
        value: 'Alarm Status'
    },
    {
        id:    'CLG',
        value: 'Cooling Mode Command'
    },
    {
        id:    'COMP_STG01_SS',
        value: 'Compressor 1 Command'
    },
    {
        id:    'COMP_STG02_SS',
        value: 'Compressor 2 Command'
    },
    {
        id:    'EF_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'EF_Enable',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'EF_Fault',
        value: 'Alarm Status'
    },
    {
        id:    'EF_Speed',
        value: 'Exhaust Fan Speed'
    },
    {
        id:    'EF_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'Main_CUP_CHW_plant_inAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_CHW_plant_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_CW_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_CHW_plant_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_NO_chillers_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_NO_CHWPs_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Glycol_plant_inAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_chillers_NOT_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_CHWP_NOT_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_Min_req_CWP_NOT_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_Chillers_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_CHWP_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Main_CUP_no_CWP_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'nvoAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'nvoAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'nvoDischAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'nvoEffectFlowSP',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'nvoEffectFlowSP',
        value: ' Supply Air Flow Setpoint'
    },
    {
        id:    'nvoEffectOccup',
        value: 'Occupancy Command'
    },
    {
        id:    'nvoEffectSetpt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'nvoSpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: ' Supply Damper Position Command'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'RA_T',
        value: 'Return Air Temperature'
    },
    {
        id:    'SA_P',
        value: 'Supply Air Pressure'
    },
    {
        id:    'SA_T_STP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'Space_Temp',
        value: 'Space Air Temperature'
    },
    {
        id:    'SpaceStaticPressureSetpoint',
        value: 'Space Air Pressure Setpoint'
    },
    {
        id:    'SpaceStaticPressureSetpoint',
        value: 'Space Air Pressure Setpoint'
    },
    {
        id:    'spaceTempAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'spaceTempAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'unOccST_alarmLow',
        value: 'Alarm Status'
    },
    {
        id:    'unOccST_alarmLow',
        value: 'Alarm Status'
    },
    {
        id:    'AHU_Supply_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'DA_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Discharge_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'DischargeAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'ExhaustAirTemp',
        value: 'Exhaust Air Temperature'
    },
    {
        id:    'MaxFlow',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Outside_Air_Temp',
        value: 'Outside Air Temperature'
    },
    {
        id:    'ReturnAirTemp',
        value: 'Return Air Temperature'
    },
    {
        id:    'RTU_SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'SupplyAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'SupplyAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Discharge_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Mixed_Air_Temp',
        value: 'Mixed Air Temperature'
    },
    {
        id:    'nvoDischAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'nvoSpaceTemp',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'RoomTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'SpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'SupplyAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'TempStpt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'nviOccManCmd',
        value: 'Occupancy Command'
    },
    {
        id:    'Return_Air_Temp',
        value: 'Return Air Temperature'
    },
    {
        id:    'RTU_SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Mode',
        value: 'Mode Text'
    },
    {
        id:    'Active_Setpt',
        value: 'Space Air Temperature'
    },
    {
        id:    'Air_Flow',
        value: 'Supply Air Flow'
    },
    {
        id:    'Air_Flow_Setpoint',
        value: 'Supply Air Flow'
    },
    {
        id:    'Comm_ST',
        value: 'Communication Status'
    },
    {
        id:    'Damper',
        value: 'Supply Damper Position'
    },
    {
        id:    'Eff_Occupancy',
        value: 'Occupancy Command'
    },
    {
        id:    'heatOutputPrimary',
        value: 'Heating Load'
    },
    {
        id:    'HW_VLV_POS',
        value: 'Heating Valve Position Command'
    },
    {
        id:    'MinFlowStdby',
        value: 'Supply Air Flow Min Standby Setpoint'
    },
    {
        id:    'MnFlwStdbyHt',
        value: 'Supply Air Flow Min Standby Heating Setpoint'
    },
    {
        id:    'Occ_Cool_Setpt',
        value: 'Supply Air Flow Min Standby Cooling Setpoint'
    },
    {
        id:    'Occ_Heat_Setpt',
        value: 'Supply Air Flow Min Standby Heating Setpoint'
    },
    {
        id:    'Space_CO2',
        value: 'Space Air CO'
    },
    {
        id:    'StaCool_Setpt',
        value: 'Space Air Temperature Standby Cooling Setpoint'
    },
    {
        id:    'StaHeat_Setpt',
        value: 'Space Air Temperature Standby Heating Setpoint'
    },
    {
        id:    'Zone_Setpt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'nviSetpoint',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'Occupancy',
        value: 'Occupancy Status'
    },
    {
        id:    'AirChangesPerHour',
        value: 'Active Air Changes'
    },
    {
        id:    'AuxiliaryHeatOutput',
        value: 'Need to check if it is Float or BP'
    },
    {
        id:    'Comm_Status',
        value: 'Communication Status'
    },
    {
        id:    'CommStatus',
        value: 'Communication Status'
    },
    {
        id:    'CoolOutput',
        value: 'Cooling Load'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Unoccupied Cooling Setpoint'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Standby Cooling Setpoint'
    },
    {
        id:    'DischargeAirHumidity',
        value: 'Supply Air Relative Humidity'
    },
    {
        id:    'DoorContact',
        value: 'Door Open Status'
    },
    {
        id:    'EffectiveSetpoint',
        value: 'Need to check to see what this is controlling'
    },
    {
        id:    'ElectricReheatStage1',
        value: 'Heating Stage 1 Command'
    },
    {
        id:    'ElectricReheatStage2',
        value: 'Heating Stage 2 Command'
    },
    {
        id:    'ElectricReheatStage3',
        value: 'Heating Stage 3 Command'
    },
    {
        id:    'ExhaustAirDamperPosition',
        value: 'Exhaust Damper Position Command'
    },
    {
        id:    'ExhaustAirDamperPosition',
        value: 'Exhaust Air Flow'
    },
    {
        id:    'ExhaustAirFlowSetpoint',
        value: 'Exhaust Air Flow Setpoint'
    },
    {
        id:    'ExhaustFanOnOff',
        value: 'Exhaust Air Flow Setpoint'
    },
    {
        id:    'ExhaustFanStatus',
        value: 'Exhaust Fan Starts'
    },
    {
        id:    'ExhaustFanVFDPercent',
        value: 'Exhaust Fan Speed Command'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Unoccupied Cooling Setpoint'
    },
    {
        id:    'CoolSetpt_Occ',
        value: 'Space Air Temperature Standby Cooling Setpoint'
    },
    {
        id:    'MinFlowStandby',
        value: 'Supply Air Flow Min Standby Setpoint'
    },
    {
        id:    'MinFlowUnitHeat',
        value: 'Supply Air Flow Min Heating Setpoint'
    },
    {
        id:    'NegativePressureMode',
        value: 'No Sensor Type'
    },
    {
        id:    'NominalFlow',
        value: 'No Sensor Type'
    },
    {
        id:    'NumericSwitch1',
        value: 'No Sensor Type'
    },
    {
        id:    'nviRequest_objectRequest',
        value: 'No Sensor Type'
    },
    {
        id:    'objectName',
        value: 'No Sensor Type'
    },
    {
        id:    'occStatusMappings',
        value: 'No Sensor Type'
    },
    {
        id:    'OverrideSetpoint',
        value: 'No Sensor Type'
    },
    {
        id:    'ReheatOutput',
        value: 'Need to check object to identify'
    },
    {
        id:    'ReturnAirFlow',
        value: 'Return Air Flow'
    },
    {
        id:    'ReturnAirFlowSetpoint',
        value: 'Return Air Flow Setpoint'
    },
    {
        id:    'ReturnAirFlowSetpoint',
        value: 'Return Damper Position Command'
    },
    {
        id:    'returnEquipmentTag',
        value: 'No Sensor Type'
    },
    {
        id:    'ReturnFanOutput',
        value: 'Need to check object to identify'
    },
    {
        id:    'ReturnFlowCalibrationFactor',
        value: 'No Sensor Type'
    },
    {
        id:    'SetbackSet',
        value: 'No Sensor Type'
    },
    {
        id:    'SpaceCO2',
        value: 'Space Air CO2'
    },
    {
        id:    'SpaceHumidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'SpaceHumiditySetpoint',
        value: 'Space Air Relative Humidity Setpoint'
    },
    {
        id:    'SpaceStaticPressure',
        value: 'Space Air Pressure'
    },
    {
        id:    'SpaceStaticPressure',
        value: 'Space Air Pressure Setpoint'
    },
    {
        id:    'SupplyAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'SupplyAirFlowSetpoint',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'SupplyDamperPosition',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'SupplyFanOutput',
        value: 'Need to check object to identify'
    },
    {
        id:    'SupplyFlowCalibrationFactor',
        value: 'No Sensor Type'
    },
    {
        id:    'TextBlock7',
        value: 'No Sensor Type'
    },
    {
        id:    'unitStatusModeMappings',
        value: 'No Sensor Type'
    },
    {
        id:    'Chilled_Water_Valve',
        value: 'Cooling Valve Position Command'
    },
    {
        id:    'CHW_Ovr',
        value: 'No Sensor Type'
    },
    {
        id:    'Duct_Static',
        value: 'Supply Air Pressure'
    },
    {
        id:    'Heat_Cool_Mode',
        value: 'Need to check object to identify'
    },
    {
        id:    'High_Static_Press_Cutout',
        value: 'No Sensor Type'
    },
    {
        id:    'HWV_Ovr',
        value: 'No Sensor Type'
    },
    {
        id:    'nviApplicMode1',
        value: 'No Sensor Type'
    },
    {
        id:    'nviOccManCmd1',
        value: 'No Sensor Type'
    },
    {
        id:    'nvoUnitStatus1_mode',
        value: 'No Sensor Type'
    },
    {
        id:    'OAD_Ovr',
        value: 'No Sensor Type'
    },
    {
        id:    'Outside_Air_Damper',
        value: 'Outside Air Damper Position Command'
    },
    {
        id:    'Sfan_VFD_Ovr',
        value: 'No Sensor Type'
    },
    {
        id:    'Supply_Fan_Fail_Reset',
        value: 'No Sensor Type'
    },
    {
        id:    'Supply_Fan_Failure',
        value: 'Supply Fan 1 Alarm'
    },
    {
        id:    'Supply_Fan_Reset',
        value: 'No Sensor Type'
    },
    {
        id:    'Supply_Fan_SS',
        value: 'Supply Fan Command'
    },
    {
        id:    'Supply_Fan_Status',
        value: 'Supply Fan Status'
    },
    {
        id:    'Supply_Fan_VFD',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'Act_CoolSP',
        value: 'Space Air Temperature Cooling Setpoint'
    },
    {
        id:    'Act_HeatSP',
        value: 'Space Air Temperature Heating Setpoint'
    },
    {
        id:    'Act_SpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'Active$20Cool$2eHeat$20Setpoint$20Temperature',
        value: 'Supply Water Temperature Setpoint'
    },
    {
        id:    'Active$20Current$20Limit$20Setpoint',
        value: 'Capacity Max Command'
    },
    {
        id:    'Active_Mode',
        value: 'Cooling Mode Command'
    },
    {
        id:    'Actual$20Running$20Capacity',
        value: 'Capacity'
    },
    {
        id:    'AHU_SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Airflow',
        value: 'Supply Air Flow'
    },
    {
        id:    'Alarm$20Present',
        value: 'Alarm Status'
    },
    {
        id:    'Average$20Motor$20Current',
        value: 'Compressor Current'
    },
    {
        id:    'Average$20Motor$20Current$20$25$20RLA',
        value: 'Capacity'
    },
    {
        id:    'BAS$20Chiller$20Auto$20Stop$20Command',
        value: 'Chiller Command'
    },
    {
        id:    'BAS$20Chiller$20Mode$20Command',
        value: 'Mode Command Enum'
    },
    {
        id:    'Basin_CT02_overStpt',
        value: 'Alarm Status'
    },
    {
        id:    'Basin_CT03_overStpt',
        value: 'Alarm Status'
    },
    {
        id:    'Basin_Temp_Alarm_Stpt',
        value: 'Condenser Leaving Water Temperature Low Limit'
    },
    {
        id:    'Basin_Temp_CT01',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Basin_Temp_CT02',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Basin_Temp_CT03',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'basSetpoint',
        value: 'No Sensor Type'
    },
    {
        id:    'BedTwr_CHW_plant_inAlarm',
        value: 'Alarm Status'
    },
    {
        id:    'BedTwr_CHW_plant_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'BedTwr_CW_supply_temp_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'BedTwr_NO_chillers_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'BedTwr_NO_CHWP_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'BedTwr_NO_CWP_running_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'Bldg_CHWRet_Temp',
        value: 'Secondary Return Water Temperature'
    },
    {
        id:    'Bldg_CHWSup_Temp',
        value: 'Secondary Supply Water Temperature'
    },
    {
        id:    'Calc_AirChanges',
        value: 'Active Air Changes'
    },
    {
        id:    'CDW_Ent_Temp',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'CDW_Iso_CC_01',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDW_Iso_CC_02',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDW_Iso_CC_03',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDW_Lvg_Temp',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'CDW_Pump_Cmd_01',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDW_Pump_Cmd_02',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDW_Pump_Cmd_03',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDW_Pump_Cmd_04',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDW_Pump_Cmd_05',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDW_Pump_Sts_01',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'CDW_Pump_Sts_02',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'CDW_Pump_Sts_03',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'CDW_Pump_Sts_04',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'CDW_Pump_Sts_05',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'CDWP_CMD_GUI_01',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDWP_CMD_GUI_02',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDWP_CMD_GUI_03',
        value: 'Condenser Water Pump Command'
    },
    {
        id:    'CDWP_Failed_01',
        value: 'Alarm Status'
    },
    {
        id:    'CDWP_Failed_02',
        value: 'Alarm Status'
    },
    {
        id:    'CDWP_Failed_03',
        value: 'Alarm Status'
    },
    {
        id:    'CDWP_Iso_CC_01',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDWP_Iso_CC_02',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDWP_Iso_CC_03',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CDWP_Iso_Sts_01',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CDWP_Iso_Sts_02',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CDWP_Iso_Sts_03',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CDWP_Needed_GUI',
        value: 'No Sensor Type'
    },
    {
        id:    'CH01_RunTime',
        value: 'Compressor Runtime'
    },
    {
        id:    'CH02_RunTime',
        value: 'Compressor Runtime'
    },
    {
        id:    'CH03_RunTime',
        value: 'Compressor Runtime'
    },
    {
        id:    'Chiller$20Auto$20Stop$20Command',
        value: 'Chiller Command'
    },
    {
        id:    'Chiller$20Control$20Mode',
        value: 'Cooling Mode Status'
    },
    {
        id:    'Chiller$20Design$20Capacity',
        value: 'Design Capacity'
    },
    {
        id:    'Chiller$20Mode$20Command',
        value: 'Mode Command Enum'
    },
    {
        id:    'Chiller$20Running',
        value: 'Chiller Status'
    },
    {
        id:    'Chiller$20Running$20State',
        value: 'Chiller Status'
    },
    {
        id:    'Chiller$20Running$20Status',
        value: 'Mode Status Enum'
    },
    {
        id:    'Chiller_CMD_GUI_01',
        value: 'Chiller Command'
    },
    {
        id:    'Chiller_CMD_GUI_02',
        value: 'Chiller Command'
    },
    {
        id:    'Chiller_CMD_GUI_03',
        value: 'Chiller Command'
    },
    {
        id:    'Chiller_Failed_01',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_Failed_02',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_Failed_03',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_01',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_02',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_inAlarm_03',
        value: 'Alarm Status'
    },
    {
        id:    'Chiller_RunStatus_01',
        value: 'Chiller Status'
    },
    {
        id:    'Chiller_RunStatus_02',
        value: 'Chiller Status'
    },
    {
        id:    'Chiller_RunStatus_03',
        value: 'Chiller Status'
    },
    {
        id:    'CHW_Bypass_Bldg_Pos_GUI',
        value: 'Bypass Valve Position'
    },
    {
        id:    'CHW_Bypass_Bldg_Vlv_GUI',
        value: 'Bypass Valve Position Command'
    },
    {
        id:    'CHW_DP_Sens',
        value: 'Secondary Differential Water Pressure'
    },
    {
        id:    'CHW_DP_Stpt_GUI',
        value: 'Secondary Differential Water Pressure Setpoint'
    },
    {
        id:    'CHW_Iso_CC_01',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CHW_Iso_CC_02',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CHW_Iso_CC_03',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CHW_Pump_Cmd_02',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Cmd_03',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Cmd_04',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Cmd_05',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Sts_02',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Sts_03',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Sts_04',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Pump_Sts_05',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHW_Supply_Stpt_GUI',
        value: 'Secondary Supply Water Temperature Setpoint'
    },
    {
        id:    'CHWP_CMD_GUI_01A',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWP_CMD_GUI_01B',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWP_CMD_GUI_01C',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWP_Failed_01A',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_Failed_01B',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_Failed_01C',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_Failure_01',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_Failure_02',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_Failure_03',
        value: 'Alarm Status'
    },
    {
        id:    'CHWP_RunStatus_01A',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWP_RunStatus_01B',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWP_RunStatus_01C',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWP_RunTime_01A',
        value: 'Recirculation Pump Runtime'
    },
    {
        id:    'CHWP_RunTime_01B',
        value: 'Recirculation Pump Runtime'
    },
    {
        id:    'CHWP_RunTime_01C',
        value: 'Recirculation Pump Runtime'
    },
    {
        id:    'CHWP_SS_01_GUI',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWP_SS_02_GUI',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWP_SS_03_GUI',
        value: 'Primary Chilled Water Pump Command'
    },
    {
        id:    'CHWPStatus_01',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWPStatus_02',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWPStatus_03',
        value: 'Primary Chilled Water Pump Status'
    },
    {
        id:    'CHWV_GUI',
        value: 'Cooling Valve Position Command'
    },
    {
        id:    'CHWVPosition',
        value: 'Cooling Valve Position Command'
    },
    {
        id:    'CHWVStatus',
        value: 'Cooling Valve Position'
    },
    {
        id:    'Compressor$201A$20Running',
        value: 'Compressor Status'
    },
    {
        id:    'Compressor$20Running',
        value: 'Compressor Status'
    },
    {
        id:    'Compressor$20Running$20Time',
        value: 'Compressor Runtime'
    },
    {
        id:    'Compressor$20Starts',
        value: 'Compressor Starts'
    },
    {
        id:    'Cond$20Entering$20Temp',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'Cond$20Leaving$20Temp',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Cond$20Rfgt$20Pressure',
        value: 'Condenser Saturated Refrigerant Pressure'
    },
    {
        id:    'Cond$20Sat$20Rfgt$20Temp',
        value: 'Condenser Saturated Refrigerant Temperature'
    },
    {
        id:    'Condenser$20Entering$20Water$20Temp',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'Condenser$20High$20Pressure$20Cutout$20Chiller',
        value: 'Condenser Saturated Refrigerant Pressure High Limit'
    },
    {
        id:    'Condenser$20Leaving$20Water$20Temp',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Condenser$20Refrigerant$20Pressure$20$2d$20Ckt$201',
        value: 'Condenser Saturated Refrigerant Pressure'
    },
    {
        id:    'Condenser$20Saturated$20Refrigerant$20Temperature$20$2d$20Ckt$202',
        value: 'Condenser Saturated Refrigerant Temperature'
    },
    {
        id:    'Condenser$20Water$20Flow',
        value: 'Condenser Entering Water Flow Status'
    },
    {
        id:    'Condenser$20Water$20Flow$20Status',
        value: 'Condenser Entering Water Flow Status'
    },
    {
        id:    'CT_01_CMD_GUI',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CT_02_CMD_GUI',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CT_03_CMD_GUI',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CT_Fan_Failed_01',
        value: 'Alarm Status'
    },
    {
        id:    'CT_Fan_Failed_02',
        value: 'Alarm Status'
    },
    {
        id:    'CT_Fan_Failed_03',
        value: 'Alarm Status'
    },
    {
        id:    'CT_Fan_Spd_GUI_01',
        value: 'Condenser Fan Speed Command'
    },
    {
        id:    'CT_Fan_Spd_GUI_02',
        value: 'Condenser Fan Speed Command'
    },
    {
        id:    'CT_Fan_Spd_GUI_03',
        value: 'Condenser Fan Speed Command'
    },
    {
        id:    'CTFan_01_Spd_GUI',
        value: 'Condenser Fan Speed Command'
    },
    {
        id:    'CTFan_02_Spd_GUI',
        value: 'Condenser Fan Speed Command'
    },
    {
        id:    'CTFan_Iso_CC_01',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CTFan_Iso_CC_02',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CTFan_Iso_CC_03',
        value: 'Isolation Valve Open Command'
    },
    {
        id:    'CTFan_Iso_Sts_01',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CTFan_Iso_Sts_02',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CTFan_Iso_Sts_03',
        value: 'Isolation Valve Open Status'
    },
    {
        id:    'CTFan_SS_01',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CTFan_SS_02',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CTFan_SS_03',
        value: 'Condenser Fan Command'
    },
    {
        id:    'CTower_Failed_01',
        value: 'Alarm Status'
    },
    {
        id:    'CTower_Failed_02',
        value: 'Alarm Status'
    },
    {
        id:    'CTower_Failed_03',
        value: 'Alarm Status'
    },
    {
        id:    'CTower_RunStatus_01',
        value: 'Condenser Fan Status'
    },
    {
        id:    'CTower_RunStatus_02',
        value: 'Condenser Fan Status'
    },
    {
        id:    'CTower_RunStatus_03',
        value: 'Condenser Fan Status'
    },
    {
        id:    'CurrentDASP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'CurrentlyInSmokeMode',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'CurrentOAFLow',
        value: 'Outside Air Flow'
    },
    {
        id:    'CurrentRAFlow',
        value: 'Return Air Flow'
    },
    {
        id:    'CurrentStaticPressureSP',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'DA_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Damper_Pos',
        value: 'Return Damper Position Command'
    },
    {
        id:    'Damper_Postion',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'DAT_SP_Max_GUI',
        value: 'Supply Air Temperature Max Setpoint'
    },
    {
        id:    'DAT_SP_Min_GUI',
        value: 'Supply Air Temperature Min Setpoint'
    },
    {
        id:    'Deadband',
        value: 'Space Air Temperature Deadband'
    },
    {
        id:    'Disable_CDWP_01',
        value: 'Enable'
    },
    {
        id:    'Disable_CDWP_02',
        value: 'Enable'
    },
    {
        id:    'Disable_CDWP_03',
        value: 'Enable'
    },
    {
        id:    'Disable_CHWP_01',
        value: 'Enable'
    },
    {
        id:    'Disable_CHWP_02',
        value: 'Enable'
    },
    {
        id:    'Disable_CHWP_03',
        value: 'Enable'
    },
    {
        id:    'DisableCT_01',
        value: 'Enable'
    },
    {
        id:    'DisableCT_02',
        value: 'Enable'
    },
    {
        id:    'DisableCT_03',
        value: 'Enable'
    },
    {
        id:    'Discharge_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'DischargeSP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'DuctPressure',
        value: 'Supply Air Pressure'
    },
    {
        id:    'DuctStaticHighLimit',
        value: 'Supply Air Pressure High Limit'
    },
    {
        id:    'DuctStaticSP',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'EF_18_Fan_And_DampersNC',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'Eff_Flow_Stpt_GUI',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'Eff_Mode',
        value: 'Occupancy Status Enum'
    },
    {
        id:    'Eff_Static_SP',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'EffFlowSP',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'ESTOP',
        value: 'Alarm Status'
    },
    {
        id:    'Evap$20Entering$20Temp',
        value: 'Evaporator Entering Water Temperature'
    },
    {
        id:    'Evap$20Leaving$20Temp',
        value: 'Evaporator Leaving Water Temperature'
    },
    {
        id:    'Evap$20Rfgt$20Pressure',
        value: 'Evaporator Saturated Refrigerant Pressure'
    },
    {
        id:    'Evap$20Sat$20Rfgt$20Temp',
        value: 'Evaporator Saturated Refrigerant Temperature'
    },
    {
        id:    'Evaporator$20Entering$20Water$20Temp',
        value: 'Evaporator Entering Water Temperature'
    },
    {
        id:    'Evaporator$20Leaving$20Water$20Temp',
        value: 'Evaporator Leaving Water Temperature'
    },
    {
        id:    'Evaporator$20Saturated$20Refrigerant$20Temperature$20$2d$20Ckt$201',
        value: 'Evaporator Saturated Refrigerant Temperature'
    },
    {
        id:    'Evaporator$20Water$20Flow',
        value: 'Supply Water Flow Status'
    },
    {
        id:    'Evaporator$20Water$20Flow$20Lost$20Chiller',
        value: 'Alarm Status'
    },
    {
        id:    'Evaporator$20Water$20Flow$20Status',
        value: 'Supply Water Flow Status'
    },
    {
        id:    'ExhaustFan6_SS',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'ExhaustFan7_SS',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'ExhaustSmokeDampersOut',
        value: 'Exhaust Damper Open Command'
    },
    {
        id:    'Failure_Reset_CDWP_01',
        value: 'No Sensor Type'
    },
    {
        id:    'Failure_Reset_CDWP_02',
        value: 'No Sensor Type'
    },
    {
        id:    'Failure_Reset_CDWP_03',
        value: 'No Sensor Type'
    },
    {
        id:    'Failure_Reset_CT_01',
        value: 'No Sensor Type'
    },
    {
        id:    'Failure_Reset_CT_02',
        value: 'No Sensor Type'
    },
    {
        id:    'Failure_Reset_CT_03',
        value: 'No Sensor Type'
    },
    {
        id:    'Fan_Spd_Enbl_Stpt',
        value: 'Condenser Fan Speed Min Command'
    },
    {
        id:    'FinalFilter',
        value: 'Air Filter Alarm Status'
    },
    {
        id:    'FlowMtr_CHWRet_GUI',
        value: 'Secondary Return Water Flow'
    },
    {
        id:    'FlowMtr_CHWSup_GUI',
        value: 'Secondary Supply Water Flow'
    },
    {
        id:    'FreezeStat',
        value: 'Freezestat Alarm Status'
    },
    {
        id:    'GeneralSmokeContact',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'GlycolV_GUI',
        value: 'Glycol Valve Command'
    },
    {
        id:    'GUI_BasinHeater_Stpt',
        value: 'Cooling Tower Basin Temperature Setpoint'
    },
    {
        id:    'GUI_CDW_Bypass_Stpt',
        value: 'Condenser Entering Water Temperature Low Limit'
    },
    {
        id:    'GUI_CDW_BypassVlv',
        value: 'Bypass Valve Open Command'
    },
    {
        id:    'GUI_CDW_Lvg_Stpt',
        value: 'Condenser Leaving Water Temperature Low Limit'
    },
    {
        id:    'GUI_CDW_Need',
        value: 'No Sensor Type'
    },
    {
        id:    'GUI_Iso_Sts_Bypass',
        value: 'Bypass Valve Open Status'
    },
    {
        id:    'GUI_Lvg_Iso_Pos_CDWP_01',
        value: 'Isolation Valve Position Command'
    },
    {
        id:    'GUI_Lvg_Iso_Pos_CDWP_02',
        value: 'Isolation Valve Position Command'
    },
    {
        id:    'GUI_Lvg_Iso_Pos_CDWP_03',
        value: 'Isolation Valve Position Command'
    },
    {
        id:    'GUI_Lvg_Iso_Sts_CDWP_01',
        value: 'Isolation Valve Position'
    },
    {
        id:    'GUI_Lvg_Iso_Sts_CDWP_02',
        value: 'Isolation Valve Position'
    },
    {
        id:    'GUI_Lvg_Iso_Sts_CDWP_03',
        value: 'Isolation Valve Position'
    },
    {
        id:    'GUI_SS_BasinHtr_01',
        value: 'Heating Stage Command'
    },
    {
        id:    'GUI_SS_BasinHtr_02',
        value: 'Heating Stage Command'
    },
    {
        id:    'GUI_SS_BasinHtr_03',
        value: 'Heating Stage Command'
    },
    {
        id:    'HCDeadband',
        value: 'Space Air Temperature Deadband'
    },
    {
        id:    'Heat_Active_GUI',
        value: 'Heating Laod'
    },
    {
        id:    'HeatCoolMode',
        value: 'Heating Mode Command'
    },
    {
        id:    'High$20Evaporator$20Refrigerant$20Temperature$20Chiller',
        value: 'Evaporator Saturated Refrigerant Temperature High Limit'
    },
    {
        id:    'High$20Evaporator$20Water$20Temperature$20Chiller',
        value: 'Supply Water Temperature High Limit'
    },
    {
        id:    'High$20Oil$20Temperature$20Chiller',
        value: 'Oil Temperature High Limit'
    },
    {
        id:    'High$20Side$20Oil$20Pressure$20$2d$20Compressor$202A',
        value: 'Compressor Oil Pressure'
    },
    {
        id:    'High_Static',
        value: 'High Static Pressure Alarm'
    },
    {
        id:    'HighStaticCutout',
        value: 'High Static Pressure Alarm'
    },
    {
        id:    'Hot$20Water$20Setpoint',
        value: 'Supply Water Temperature Heating Setpoint'
    },
    {
        id:    'Humidifier1A',
        value: 'Humidifier Position Command'
    },
    {
        id:    'Humidifier1AEnable',
        value: 'Humidifier Command'
    },
    {
        id:    'Humidifier1B',
        value: 'Humidifier Position Command'
    },
    {
        id:    'Humidifier1BEnable',
        value: 'Humidifier Command'
    },
    {
        id:    'HumidifierGUI',
        value: 'Humidifier Command'
    },
    {
        id:    'HumiditySensor',
        value: 'Supply Air Relative Humidity'
    },
    {
        id:    'HumStpt',
        value: 'Space Air Relative Humidity Setpoint'
    },
    {
        id:    'HWV_Cmd',
        value: 'Heating Valve Position Command'
    },
    {
        id:    'HWV_GUI',
        value: 'Heating Valve Position Command'
    },
    {
        id:    'HWVPosition',
        value: 'Heating Valve Position Command'
    },
    {
        id:    'HWVStatus',
        value: 'Heating Valve Position'
    },
    {
        id:    'IGV1$20Position',
        value: 'Inlet Guide Vanes Position'
    },
    {
        id:    'IGV1$20Position',
        value: 'Inlet Guide Vanes Position'
    },
    {
        id:    'IGV1$20Position',
        value: 'Inlet Guide Vanes Position'
    },
    {
        id:    'input_activeCoolSetpnt',
        value: 'Space Air Temperature Cooling Setpoint'
    },
    {
        id:    'input_activeHeatSetpnt',
        value: 'Space Air Temperature Heating Setpoint'
    },
    {
        id:    'is_CHWP_running$3f',
        value: 'Recirculation Pump Status'
    },
    {
        id:    'is_CWP_running$3f',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'is_CWP_running?',
        value: 'Condenser Entering Water Flow Status'
    },
    {
        id:    'LeadCDWP',
        value: 'No Sensor Type'
    },
    {
        id:    'LeadCT',
        value: 'No Sensor Type'
    },
    {
        id:    'Line$201$20Current$20$28$25RLA$29$20$2d$20Compressor$201A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$201$20Current$20$28$25RLA$29$20$2d$20Compressor$202A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$201$20Current$20$28in$20Amps$29$20$2d$20Compressor$201A',
        value: 'Current'
    },
    {
        id:    'Line$201$20Current$20$28in$20Amps$29$20$2d$20Compressor$202A',
        value: 'Current'
    },
    {
        id:    'Line$202$20Current$20$28$25RLA$29$20$2d$20Compressor$201A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$202$20Current$20$28$25RLA$29$20$2d$20Compressor$202A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$202$20Current$20$28in$20Amps$29$20$2d$20Compressor$201A',
        value: 'Current'
    },
    {
        id:    'Line$202$20Current$20$28in$20Amps$29$20$2d$20Compressor$202A',
        value: 'Current'
    },
    {
        id:    'Line$203$20Current$20$28$25RLA$29$20$2d$20Compressor$201A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$203$20Current$20$28$25RLA$29$20$2d$20Compressor$202A',
        value: 'Compressor Capacity'
    },
    {
        id:    'Line$203$20Current$20$28in$20Amps$29$20$2d$20Compressor$201A',
        value: 'Current'
    },
    {
        id:    'Line$203$20Current$20$28in$20Amps$29$20$2d$20Compressor$202A',
        value: 'Current'
    },
    {
        id:    'Local$20Atmospheric$20Pressure',
        value: 'Outside Air Pressure'
    },
    {
        id:    'Low$20Differential$20Oil$20Pressure$20Chiller',
        value: 'Oil Pressure Low Limit'
    },
    {
        id:    'Low$20Evaporator$20Refrigerant$20Temperature$20Chiller',
        value: 'Evaporator Saturated Refrigerant Temperature Low Limit'
    },
    {
        id:    'LowLimit',
        value: 'Freezestat Alarm Status'
    },
    {
        id:    'LowLimit(Auto)',
        value: 'Freezestat Alarm Status'
    },
    {
        id:    'LowStaticCutout',
        value: 'Low Static Pressure Alarm'
    },
    {
        id:    'ManualRotateCHWPumps',
        value: 'No Sensor Type'
    },
    {
        id:    'ManualRotateCT',
        value: 'No Sensor Type'
    },
    {
        id:    'Master_CT_Fan_Spd_GUI',
        value: 'No Sensor Type'
    },
    {
        id:    'MATemp',
        value: 'Mixed Air Temperature'
    },
    {
        id:    'Max_Flow_Stpt',
        value: 'Supply Air Flow Max Setpoint'
    },
    {
        id:    'MaxFlow',
        value: 'Supply Air Flow Max Setpoint'
    },
    {
        id:    'Min_Cool_Flow_Stpt',
        value: 'Supply Air Flow Min Cooling Setpoint'
    },
    {
        id:    'Min_Heat_Flow_Stpt',
        value: 'Supply Air Flow Min Heating Setpoint'
    },
    {
        id:    'MinFlow',
        value: 'Supply Air Flow Min Cooling Setpoint'
    },
    {
        id:    'MinFlowHeat',
        value: 'Supply Air Flow Min Heating Setpoint'
    },
    {
        id:    'MinFlowStandby',
        value: 'Supply Air Flow Min Standby Setpoint'
    },
    {
        id:    'Mixed_Prs_GUI',
        value: 'Mixed Air Pressure'
    },
    {
        id:    'MixedAirTemp',
        value: 'Mixed Air Temperature'
    },
    {
        id:    'MixedPressure',
        value: 'Mixed Air Pressure'
    },
    {
        id:    'MP_Setpoint',
        value: 'Mixed Air Pressure Setpoint'
    },
    {
        id:    'NextLeadCDWP',
        value: 'No Sensor Type'
    },
    {
        id:    'NextLeadCT',
        value: 'No Sensor Type'
    },
    {
        id:    'NumTowersNeeded_GUI',
        value: 'No Sensor Type'
    },
    {
        id:    'OA_CFM_Calc_GUI',
        value: 'Outside Air Flow'
    },
    {
        id:    'OA_DamperGUI',
        value: 'Outside Air Damper Position Command'
    },
    {
        id:    'OA_Flow_SP',
        value: 'Outside Air Flow Setpoint'
    },
    {
        id:    'OA_SmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'OADamper',
        value: 'Outside Air Damper Position Command'
    },
    {
        id:    'OAFMS_GUI',
        value: 'Outside Air Flow'
    },
    {
        id:    'OAHumidity',
        value: 'Outside Air Relative Humidity'
    },
    {
        id:    'OAT_Changeover',
        value: 'Heating Mode On Setpoint'
    },
    {
        id:    'OAT_In',
        value: 'Outside Air Temperature'
    },
    {
        id:    'OATemp',
        value: 'Outside Air Temperature'
    },
    {
        id:    'OATemperature',
        value: 'Outside Air Temperature'
    },
    {
        id:    'Occupancy',
        value: 'Occupancy Command'
    },
    {
        id:    'Occupancy_Mode_In',
        value: 'Occupancy Command'
    },
    {
        id:    'OccupancyCMD',
        value: 'Occupancy Command'
    },
    {
        id:    'OccupancyStatus',
        value: 'Occupancy Status'
    },
    {
        id:    'Oil$20Differential$20Pressure',
        value: 'Oil Pressure'
    },
    {
        id:    'Oil$20Pump$20Discharge$20Pressure',
        value: 'Compressor Oil Pressure'
    },
    {
        id:    'Oil$20Tank$20Pressure',
        value: 'Oil Pressure'
    },
    {
        id:    'Oil$20Tank$20Temperature',
        value: 'Oil Temperature'
    },
    {
        id:    'Operating$20Mode',
        value: 'Mode Status Enum'
    },
    {
        id:    'OR_25_Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_25_Humidity_GUI',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_25_Pressure',
        value: 'Space Air Pressure'
    },
    {
        id:    'OR_25_Pressure_GUI',
        value: 'Space Air Pressure'
    },
    {
        id:    'OR_26_Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_26_Humidity_GUI',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_26_Pressure',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_26_Pressure_GUI',
        value: 'Space Air Pressure'
    },
    {
        id:    'OR_27_Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_27_Humidity_GUI',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'OR_27_Pressure',
        value: 'Space Air Pressure'
    },
    {
        id:    'OR_27_Pressure_GUI',
        value: 'Space Air Pressure'
    },
    {
        id:    'Or2',
        value: 'Not a Sensor'
    },
    {
        id:    'OutsideSmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'Phase$20AB$20Voltage$20$2d$20Compressor$201A',
        value: 'Compressor Voltage'
    },
    {
        id:    'Phase$20BC$20Voltage$20$2d$20Compressor$201A',
        value: 'Compressor Voltage'
    },
    {
        id:    'Phase$20CA$20Voltage$20$2d$20Compressor$201A',
        value: 'Compressor Voltage'
    },
    {
        id:    'Plnt_CHWRet_Temp',
        value: 'Primary Return Water Temperature'
    },
    {
        id:    'Pre_Filter',
        value: 'Air Filter Alarm Status'
    },
    {
        id:    'PreCoolingSP',
        value: 'PreCooling Supply Air Temp Setpoint'
    },
    {
        id:    'PreCoolingSupply',
        value: 'PreCooling Supply Air Temp'
    },
    {
        id:    'PreFilter',
        value: 'Air Prefilter Differential Pressure'
    },
    {
        id:    'PreHeatingSupply',
        value: 'Preheat Air Temperature'
    },
    {
        id:    'PreHeatingSupplySP',
        value: 'Preheat Air Temperature Setpoint'
    },
    {
        id:    'PreHeatSetpoint',
        value: 'Preheat Air Temperature Setpoint'
    },
    {
        id:    'Present_Mode',
        value: 'Occupancy Command'
    },
    {
        id:    'Press_Transducer',
        value: 'Supply Air Flow'
    },
    {
        id:    'Purge_Fan_SS',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'Purge_Fan_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'RA_DamperGUI',
        value: 'Return Damper Position Command'
    },
    {
        id:    'RA_DamperReset',
        value: 'Return Damper Position Command'
    },
    {
        id:    'RA_DamperScrewWithChris',
        value: 'Return Damper Position Command'
    },
    {
        id:    'RA_SmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'RA_Temp',
        value: 'Return Air Temperature'
    },
    {
        id:    'RADamper',
        value: 'Return Damper Position Command'
    },
    {
        id:    'RAFMS_GUI',
        value: 'Return Air Flow'
    },
    {
        id:    'Refridgerant_Alarm',
        value: 'Gas Detector Alarm Status'
    },
    {
        id:    'Ret_Temp_CT_01',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Ret_Temp_CT_02',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'Ret_Temp_CT_03',
        value: 'Condenser Leaving Water Temperature'
    },
    {
        id:    'ReturnFanSS',
        value: 'Return Fan Command'
    },
    {
        id:    'ReturnFanStatus',
        value: 'Return Fan Status'
    },
    {
        id:    'ReturnSmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'ReturnTemp',
        value: 'Return Air Temperature'
    },
    {
        id:    'ReturnVFD_GUI',
        value: 'Return Fan Speed Command'
    },
    {
        id:    'RHtMinFlow',
        value: 'Supply Air Flow Min Heating Setpoint'
    },
    {
        id:    'Room013Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'Room026Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'Room032Humidity',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'Room032HumidityIN',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'RoomHum',
        value: 'Space Air Relative Humidity '
    },
    {
        id:    'RoomHumidity',
        value: 'Return Air Relative Humidity'
    },
    {
        id:    'RoomHumidity_GUI',
        value: 'Return Air Relative Humidity'
    },
    {
        id:    'RoomHumidityLow_GUI',
        value: 'Return Air Relative Humidity'
    },
    {
        id:    'RoomHumiditySP',
        value: 'Return Air Relative Humidity Setpoint'
    },
    {
        id:    'RoomPrs',
        value: 'Space Air Pressure'
    },
    {
        id:    'RoomTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'Run$20Enable',
        value: 'Enable'
    },
    {
        id:    'Run$20Enabled',
        value: 'Enable'
    },
    {
        id:    'Run$20Time$20$2d$20Compressor$201A',
        value: 'Compressor Runtime'
    },
    {
        id:    'Run$20Time$20$2d$20Compressor$202A',
        value: 'Compressor Runtime'
    },
    {
        id:    'RunTime01',
        value: 'Condenser Fan Runtime'
    },
    {
        id:    'RunTime01',
        value: 'Condenser Fan Runtime'
    },
    {
        id:    'RunTime02',
        value: 'Condenser Fan Runtime'
    },
    {
        id:    'RunTime03',
        value: 'Condenser Fan Runtime'
    },
    {
        id:    'SA_Humidity_GUI',
        value: 'Return Air Relative Humidity'
    },
    {
        id:    'SA_SmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'SAFMS_GUI',
        value: 'Supply Air Flow'
    },
    {
        id:    'SEF_3_SS',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'SEF_3_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'SEF_4_SS',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'SEF_4_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'SEF1_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'SetpointHighLimit',
        value: 'Space Air Temperature Max Setpoint'
    },
    {
        id:    'SetpointLowLimit',
        value: 'Space Air Temperature Min Setpoint'
    },
    {
        id:    'Shutdown$20Alarm$20Present',
        value: 'Alarm Status'
    },
    {
        id:    'SmokeExhaustFan',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'Space_Temp',
        value: 'Space Air Temperature'
    },
    {
        id:    'SpaceHumidityLowSP',
        value: 'Space Air Relative Humidity Min Setpoint'
    },
    {
        id:    'SpaceHumiditySP',
        value: 'Space Air Relative Humidity Setpoint'
    },
    {
        id:    'SpaceSmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'Starter$20Input$20Power$20Consumption',
        value: 'Power'
    },
    {
        id:    'Starter$20Input$20Voltage$20AB',
        value: 'Voltage'
    },
    {
        id:    'Starter$20Input$20Voltage$20BC',
        value: 'Voltage'
    },
    {
        id:    'Starter$20Input$20Voltage$20CA',
        value: 'Voltage'
    },
    {
        id:    'Starter$20Motor$20Current$20L1',
        value: 'Current'
    },
    {
        id:    'Starter$20Motor$20Current$20L1$20$25$20RLA',
        value: 'Compressor Capacity'
    },
    {
        id:    'Starter$20Motor$20Current$20L2',
        value: 'Current'
    },
    {
        id:    'Starter$20Motor$20Current$20L2$20$25$20RLA',
        value: 'Compressor Capacity'
    },
    {
        id:    'Starter$20Motor$20Current$20L3',
        value: 'Current'
    },
    {
        id:    'Starter$20Motor$20Current$20L3$20$25$20RLA',
        value: 'Compressor Capacity'
    },
    {
        id:    'Starter$20Motor$20Power$20Factor',
        value: 'Compressor Power Factor'
    },
    {
        id:    'Starts$20$2d$20Compressor$201A',
        value: 'Compressor Starts'
    },
    {
        id:    'Starts$20$2d$20Compressor$202A',
        value: 'Compressor Starts'
    },
    {
        id:    'StaticPressure_GUI',
        value: 'Supply Air Pressure'
    },
    {
        id:    'StaticSP_Occ',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'stptVShum',
        value: 'Space Air Relative Humidity'
    },
    {
        id:    'stptVSprs',
        value: 'Supply Air Pressure'
    },
    {
        id:    'stpVStemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'Sts_CDWP_01',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'Sts_CDWP_02',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'Sts_CDWP_03',
        value: 'Condenser Water Pump Status'
    },
    {
        id:    'Sts_CTFan_01',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Sts_CTFan_02',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Sts_CTFan_03',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Suction$20Pressure$20$2d$20Ckt$201',
        value: 'Compressor Entering Refrigerant Pressure'
    },
    {
        id:    'SumpPump_Alarm',
        value: 'Alarm Status'
    },
    {
        id:    'Sup_Temp_CT_01',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'Sup_Temp_CT_02',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'Sup_Temp_CT_03',
        value: 'Condenser Entering Water Temperature'
    },
    {
        id:    'SupplyFanFailure',
        value: 'Supply Fan 1 Alarm'
    },
    {
        id:    'SupplyFanSS',
        value: 'Supply Fan Command'
    },
    {
        id:    'SupplyFanStatus',
        value: 'Supply Fan Status'
    },
    {
        id:    'SupplyFanVFD',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'SupplySmokeDetector',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'SupplyTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'SupplyTempSP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'SupplyVFD_GUI',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'SurgRdy',
        value: 'Occupancy Status'
    },
    {
        id:    'SurgRdy',
        value: 'Operating RoomÂ Ready'
    },
    {
        id:    'Target_RetFlow',
        value: 'Secondary Return Water Flow Setpoint'
    },
    {
        id:    'TargetAirChanges',
        value: 'Active Air Changes Setpoint'
    },
    {
        id:    'TempStpt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'UVLightStatus',
        value: 'Light Level'
    },
    {
        id:    'VAV_Actuator_PosCmd',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'VAV_Actuator_Status',
        value: 'Supply Damper Open Status'
    },
    {
        id:    'AUXILLARY_FLOW',
        value: 'Space Air Flow Max Setpoint'
    },
    {
        id:    'CFM',
        value: 'Space Air Flow'
    },
    {
        id:    'DA_T',
        value: 'Supply Air Temperature'
    },
    {
        id:    'DAMPER',
        value: 'Supply Damper Position Command'
    },
    {
        id:    'EFF_CFM_STP',
        value: 'Space Air Flow Setpoint'
    },
    {
        id:    'EFF_COOL_STPT',
        value: 'Space Air Temperature Cooling Setpoint'
    },
    {
        id:    'EFF_HEAT_STPT',
        value: 'Space Air Temperature Heating Setpoint'
    },
    {
        id:    'EFF_HVAC_MODE',
        value: 'Mode Status Enum'
    },
    {
        id:    'EFF_OCC_MODE',
        value: 'Occupancy Status'
    },
    {
        id:    'HEAT_STG_01',
        value: 'Heating Stage 1 Command'
    },
    {
        id:    'HEAT_STG_02',
        value: 'Heating Stage 2 Command'
    },
    {
        id:    'MAX_COOL_FLOW',
        value: 'Cooling Air Flow Max Setpoint'
    },
    {
        id:    'MAX_HEAT_FLOW',
        value: 'Heating Air Flow Max Setpoint'
    },
    {
        id:    'MIN_COOL_FLOW',
        value: 'Cooling Air Flow Min Setpoint'
    },
    {
        id:    'MIN_HEAT_FLOW',
        value: 'Heating Air Flow Min Setpoint'
    },
    {
        id:    'OCC_COOL_STPT',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'OCC_HEAT_STPT',
        value: 'Space Air Temperature Occupied Heating Setpoint'
    },
    {
        id:    'OCC_MODE',
        value: 'Occupancy Command'
    },
    {
        id:    'RM_T',
        value: 'Space Air Temperature'
    },
    {
        id:    'RM_T_STP',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'UNOCC_COOL_STPT',
        value: 'Space Air Temperature Unoccupied Cooling Setpoint'
    },
    {
        id:    'UNOCC_HEAT_STPT',
        value: 'Space Air Temperature Unoccupied Heating Setpoint'
    },
    {
        id:    'BACNET_SCHEDULE',
        value: 'Occupancy Command'
    },
    {
        id:    'DX_01_RUNTIME',
        value: 'Compressor Runtime'
    },
    {
        id:    'DX_02_RUNTIME',
        value: 'Compressor Runtime'
    },
    {
        id:    'DX_ALARM',
        value: 'Alarm Status'
    },
    {
        id:    'DX_LOCKOUT_STP',
        value: 'Mechanical Cooling Mode Off Setpoint'
    },
    {
        id:    'DX_STG_01',
        value: 'Cooling Stage 1 Command'
    },
    {
        id:    'DX_STG_02',
        value: 'Cooling Stage 2 Command'
    },
    {
        id:    'DX_STG_03',
        value: 'Cooling Stage 3 Command'
    },
    {
        id:    'ECON_LOCKOUT_STP',
        value: 'Economizer Mode Off Setpoint'
    },
    {
        id:    'ECON_MAX_POS_STP',
        value: 'Outside Air Damper Position Max Command'
    },
    {
        id:    'EF_RELAY',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'EF_S',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'EFF_ECON_MIN_POS',
        value: 'Outside Air Damper Position Min Command'
    },
    {
        id:    'EFF_SA_T_STP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'FILTER_ALARM',
        value: 'Air Filter Alarm Status'
    },
    {
        id:    'FILTER_RUNTIME',
        value: 'Filter Runtime'
    },
    {
        id:    'FILTER_S',
        value: 'Air Filter Alarm Status'
    },
    {
        id:    'FIRE_SHUTDOWN_ALARM',
        value: 'Smoke Detector Alarm Status'
    },
    {
        id:    'HEAT_01_RUNTIME',
        value: 'Heating Stage Runtime'
    },
    {
        id:    'HEAT_02_RUNTIME',
        value: 'Heating Stage Runtime'
    },
    {
        id:    'HEAT_ALARM',
        value: 'Alarm Status 1'
    },
    {
        id:    'HEAT_ENA',
        value: 'Heating Mode Command'
    },
    {
        id:    'HEAT_LOCKOUT_STP',
        value: 'Heating Mode Off Setpoint'
    },
    {
        id:    'HEAT_STG_01',
        value: 'Heating Stage 1 Command'
    },
    {
        id:    'HEAT_STG_02',
        value: 'Heating Stage 2 Command'
    },
    {
        id:    'HVAC_MODE',
        value: 'Mode Status Enum'
    },
    {
        id:    'mode_status',
        value: 'Mode Status Enum'
    },
    {
        id:    'OA_T',
        value: 'Outside Air Temperature'
    },
    {
        id:    'OCC_RM_T_COOL_STP',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'OCC_RM_T_HEAT_STP',
        value: 'Space Air Temperature Occupied Heating Setpoint'
    },
    {
        id:    'OCCUPANCY',
        value: 'Occupancy Status'
    },
    {
        id:    'RA_T',
        value: 'Return Air Temperature'
    },
    {
        id:    'RM_T',
        value: 'Space Air Temperature'
    },
    {
        id:    'SA_HI_STC_ALARM',
        value: 'Supply Air Pressure High Limit Status'
    },
    {
        id:    'SA_HI_STC_STP',
        value: 'Supply Air Pressure High Limit'
    },
    {
        id:    'SA_STC_STP',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'SA_T',
        value: 'Supply Air Temperature'
    },
    {
        id:    'SA_T_COOL_STP',
        value: 'Supply Air Temperature Cooling Setpoint'
    },
    {
        id:    'SA_T_HEAT_STP',
        value: 'Supply Air Temperature Heating Setpoint'
    },
    {
        id:    'SF_ALARM',
        value: 'Supply Fan 1 Alarm'
    },
    {
        id:    'SF_MIN_SPD',
        value: 'Supply Fan Min Speed Command'
    },
    {
        id:    'SF_RELAY',
        value: 'Supply Fan Command'
    },
    {
        id:    'SF_S',
        value: 'Supply Fan Status'
    },
    {
        id:    'SF_SPD',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'sfan_hand_alarm',
        value: 'Alarm Status 2'
    },
    {
        id:    'SHUTDOWN_S',
        value: 'Alarm Status 3'
    },
    {
        id:    'STC',
        value: 'Supply Air Pressure'
    },
    {
        id:    'UNOCC_RM_T_COOL_STP',
        value: 'Space Air Temperature Unoccupied Cooling Setpoint'
    },
    {
        id:    'UNOCC_RM_T_HEAT_STP',
        value: 'Space Air Temperature Unoccupied Heating Setpoint'
    },
    {
        id:    'AirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'AirFlowSetpt',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'crnt_mode',
        value: 'Mode'
    },
    {
        id:    'DB',
        value: 'Space Air Temperature Deadband'
    },
    {
        id:    'CommFail',
        value: 'Communication Status'
    },
    {
        id:    'DamperPos',
        value: 'DamperPos'
    },
    {
        id:    'DaTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'EffectOcc',
        value: 'Occupancy Status'
    },
    {
        id:    'FanOn',
        value: 'Supply Fan Command'
    },
    {
        id:    'HeatOn',
        value: 'Heating Stage Command'
    },
    {
        id:    'HeatStages',
        value: 'Heating Stage Status'
    },
    {
        id:    'MaxFlow',
        value: 'Supply Air Flow Max Setpoint'
    },
    {
        id:    'MaxFlowHeat',
        value: 'Supply Air Flow Max Heating Setpoint'
    },
    {
        id:    'MinDamperPos',
        value: 'Supply Damper Position Min Command'
    },
    {
        id:    'MinFlow',
        value: 'Supply Air MinFlow'
    },
    {
        id:    'MinFlowStdby',
        value: 'Supply Air MinFlowStdby'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: 'Cooling Load'
    },
    {
        id:    'nvoUnitStatus_heatOutputPrimary',
        value: 'Heating Load'
    },
    {
        id:    'Occupancy',
        value: 'OccupancyCommand'
    },
    {
        id:    'SpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'TempControlPt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'TempSetPts_occCool',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'TempSetPts_occHeat',
        value: 'Space Air Temperature Occupied Heating Setpoint'
    },
    {
        id:    'ActiveSp',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'CoolingLoad',
        value: 'Cooling Load'
    },
    {
        id:    'FAN_Enable',
        value: 'Supply Fan Command'
    },
    {
        id:    'HeatingLoad',
        value: 'Heating Load'
    },
    {
        id:    'HeatStages',
        value: 'Heating Stage Status'
    },
    {
        id:    'nciMaxFlow',
        value: 'Supply Air Max Flow'
    },
    {
        id:    'nciMaxFlowHeat',
        value: 'Supply Air Flow Max Heat'
    },
    {
        id:    'nciMinFlow',
        value: 'Supply Air Min Flow'
    },
    {
        id:    'nciMinFlowHeat',
        value: 'Supply Air Flow Min Heat'
    },
    {
        id:    'nciSetpoints_OccupiedCool',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'nciSetpoints_OccupiedHeat',
        value: 'Space Air Temperature Occupied Heating Setpoint'
    },
    {
        id:    'nciSetpoints_StandbyCool',
        value: 'Supply Air Standby Setpoints Cool'
    },
    {
        id:    'nciSetpoints_StandbyHeat',
        value: 'Supply Air Standby Setpoints Heat'
    },
    {
        id:    'nciSetpoints_UnoccupiedCool',
        value: 'Supply Air Unoccupied Setpoints Cool'
    },
    {
        id:    'nciSetpoints_UnoccupiedHeat',
        value: 'Supply Air Unoccupied Setpoints Heat'
    },
    {
        id:    'NumericSwitch',
        value: 'Supply Air NumericSwitch'
    },
    {
        id:    'NumericSwitch1',
        value: 'Supply Air NumericSwitch'
    },
    {
        id:    'NumericWritable',
        value: 'Supply Air NumericWritable'
    },
    {
        id:    'NumericWritable1',
        value: 'Supply Air NumericWritable'
    },
    {
        id:    'nviAirFlowSetpt',
        value: 'Supply Air Flow Air Setpt'
    },
    {
        id:    'nviApplicMode',
        value: 'Supply Air Applic Mode'
    },
    {
        id:    'nviDuctInTemp',
        value: 'Supply Air In Duct Temp'
    },
    {
        id:    'nviHeat1Override',
        value: 'Supply Air Heat Override'
    },
    {
        id:    'nviSystemToVav_DischargeTemp',
        value: 'Supply Air Discharge Vav Temp'
    },
    {
        id:    'nvoAirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'nvoDamperPos',
        value: 'Supply Damper Position'
    },
    {
        id:    'nvoDischAirTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'nvoDischTempSP',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'nvoEffectCoolSP',
        value: 'Space Air Temperature Cooling Setpoint'
    },
    {
        id:    'nvoEffectFlowSP',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'nvoEffectHeatSP',
        value: 'Space Air Temperature Heating Setpoint'
    },
    {
        id:    'nvoEffectOccup',
        value: 'Occupancy Command'
    },
    {
        id:    'nvoEffectSetpt',
        value: 'Supply Air Effect Setpt'
    },
    {
        id:    'nvoFanSpeed_state',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'nvoTerminalLoadF',
        value: 'Supply Air   F'
    },
    {
        id:    'SpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'UnitMode',
        value: 'Mode Text'
    },
    {
        id:    'AirFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'AirFlowSetpt',
        value: 'Supply Air Flow Setpoint'
    },
    {
        id:    'BoxFlow',
        value: 'Supply Air Flow'
    },
    {
        id:    'crnt_mode',
        value: 'Mode'
    },
    {
        id:    'DB1',
        value: 'Space Air Temperature Deadband'
    },
    {
        id:    'CommFail',
        value: 'Communication Status'
    },
    {
        id:    'DamperPos',
        value: 'DamperPos'
    },
    {
        id:    'DaTemp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'EffectOcc',
        value: 'Occupancy Status'
    },
    {
        id:    'FanOn',
        value: 'Supply Fan Command'
    },
    {
        id:    'HeatOn',
        value: 'Heating Stage Command'
    },
    {
        id:    'HeatStages',
        value: 'Heating Stage Status'
    },
    {
        id:    'MaxFlow',
        value: 'Supply Air Flow Max Setpoint'
    },
    {
        id:    'MaxFlowHeat',
        value: 'Supply Air Flow Max Heating Setpoint'
    },
    {
        id:    'MinDamperPos',
        value: 'Supply Damper Position Min Command'
    },
    {
        id:    'MinFlow',
        value: 'MinFlow'
    },
    {
        id:    'MinFlowStdby',
        value: 'MinFlowStdby'
    },
    {
        id:    'nvoUnitStatus_coolOutput',
        value: 'Cooling Load'
    },
    {
        id:    'nvoUnitStatus_heatOutputPrimary',
        value: 'Heating Load'
    },
    {
        id:    'Occupancy',
        value: 'OccupancyCommand'
    },
    {
        id:    'SpaceTemp',
        value: 'Space Air Temperature'
    },
    {
        id:    'TempControlPt',
        value: 'Space Air Temperature Setpoint'
    },
    {
        id:    'TempSetPts_occCool',
        value: 'Space Air Temperature Occupied Cooling Setpoint'
    },
    {
        id:    'TempSetPts_occHeat',
        value: 'Space Air Temperature Occupied Heating Setpoint'
    },
    {
        id:    'TEF1_Cmd',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'TEF1_Status',
        value: 'Exhaust Fan Status'
    },
    {
        id:    'AlarmStatus',
        value: 'Alarm Status'
    },
    {
        id:    'bldg_press_stpt',
        value: 'Site Air Pressure Setpoint'
    },
    {
        id:    'bldg_static_press',
        value: 'Site Air Pressure'
    },
    {
        id:    'Comp_A_RunHours',
        value: 'Compressor Runtime'
    },
    {
        id:    'Comp_A_Starts',
        value: 'Compressor Starts'
    },
    {
        id:    'Comp_B_RunHours',
        value: 'Compressor Runtime'
    },
    {
        id:    'CompA1_Relay',
        value: 'Compressor 1 Command'
    },
    {
        id:    'CompA2_Relay',
        value: 'Compressor 2 Command'
    },
    {
        id:    'CompB1_Relay',
        value: 'Compressor 3 Command'
    },
    {
        id:    'CompB2_Relay',
        value: 'Compressor 4 Command'
    },
    {
        id:    'condfan1',
        value: 'Condenser Fan Status'
    },
    {
        id:    'condfan2',
        value: 'Condenser Fan Status'
    },
    {
        id:    'condfan3',
        value: 'Condenser Fan Status'
    },
    {
        id:    'condfan4',
        value: 'Condenser Fan Status'
    },
    {
        id:    'CurrentClgCapacity',
        value: 'Cooling Load'
    },
    {
        id:    'econ_oat_lockout',
        value: 'Outside Air Temperature High Limit'
    },
    {
        id:    'econ_pos',
        value: 'Economizer Damper Position'
    },
    {
        id:    'EconActive',
        value: 'Economizer Mode Status'
    },
    {
        id:    'EconCurrentMinPos',
        value: 'Economizer Damper Position Min Command'
    },
    {
        id:    'HeatRelay1Status',
        value: 'Heating Stage Command'
    },
    {
        id:    'HPS_ClgCir_A_Status',
        value: 'Alarm Status 1'
    },
    {
        id:    'HPS_ClgCir_B_Status',
        value: 'Alarm Status 2'
    },
    {
        id:    'MA_Temp',
        value: 'Mixed Air Temperature'
    },
    {
        id:    'oat',
        value: 'Outside Air Temperature'
    },
    {
        id:    'occ_status',
        value: 'Occupancy Status'
    },
    {
        id:    'OccModeStatus',
        value: 'OccupancyCommand'
    },
    {
        id:    'PowerExhaustFanCmd_1',
        value: 'Exhaust Fan Command'
    },
    {
        id:    'RA_Temp',
        value: 'Return Air Temperature'
    },
    {
        id:    'sa_static_stpt',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'SA_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'sa_temp_stpt',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'SF_Command',
        value: 'Supply Fan Command'
    },
    {
        id:    'SF_Status',
        value: 'Supply Fan Status'
    },
    {
        id:    'sf_vfd_output',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'static_press',
        value: 'Supply Air Pressure'
    },
    {
        id:    'AlarmStatus',
        value: 'Alarm Status'
    },
    {
        id:    'Bldg_Static_Press',
        value: 'Site Air Pressure'
    },
    {
        id:    'Bldg_Static_Press_StPt',
        value: 'Site Air Pressure Setpoint'
    },
    {
        id:    'Clg_CircA_Hps_Status',
        value: 'Alarm Status 1'
    },
    {
        id:    'Clg_CircB_Hps_Status',
        value: 'Alarm Status 2'
    },
    {
        id:    'Comp_A_Run_Hours',
        value: 'Compressor Runtime'
    },
    {
        id:    'Comp_A_Starts',
        value: 'Compressor Starts'
    },
    {
        id:    'Comp_A2_Relay_Status',
        value: 'Compressor 2 Command'
    },
    {
        id:    'Comp_AI_Relay_Status',
        value: 'Compressor 1 Command'
    },
    {
        id:    'Comp_B_Run_Hours1',
        value: 'Compressor Runtime'
    },
    {
        id:    'Comp_B1_Relay_Status',
        value: 'Compressor 3 Command'
    },
    {
        id:    'Comp_B2_Relay_Status',
        value: 'Compressor 4 Command'
    },
    {
        id:    'Cond_Fan1_Status',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Cond_Fan2_Status',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Cond_Fan3_Status',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Cond_Fan4_Status',
        value: 'Condenser Fan Status'
    },
    {
        id:    'Current_Clg_Capacity',
        value: 'Cooling Load'
    },
    {
        id:    'Econ_Enable_Status',
        value: 'Economizer Mode Status'
    },
    {
        id:    'Econ_Min_Pos_StPt',
        value: 'Economizer Damper Position Min Command'
    },
    {
        id:    'Econ_Oat_Lockout_StPt',
        value: 'Outside Air Temperature High Limit'
    },
    {
        id:    'Econ_Position',
        value: 'Economizer Damper Position'
    },
    {
        id:    'Heat_Relay1_Status',
        value: 'Heating Stage Command'
    },
    {
        id:    'Ma_Temp',
        value: 'Mixed Air Temperature'
    },
    {
        id:    'Oat',
        value: 'Outside Air Temperature'
    },
    {
        id:    'Occ_Mode_Status',
        value: 'OccupancyCommand'
    },
    {
        id:    'Occ_Status',
        value: 'Occupancy Status'
    },
    {
        id:    'Ra_Temp',
        value: 'Return Air Temperature'
    },
    {
        id:    'Sa_Static_Press_StPt',
        value: 'Supply Air Pressure Setpoint'
    },
    {
        id:    'Sa_Temp',
        value: 'Supply Air Temperature'
    },
    {
        id:    'Sa_Temp_StPt',
        value: 'Supply Air Temperature Setpoint'
    },
    {
        id:    'Sf_VFD_Output',
        value: 'Supply Fan Speed Command'
    },
    {
        id:    'Static_Press',
        value: 'Supply Air Pressure'
    },
    {
        id:    'Supply_Fan_Command',
        value: 'Supply Fan Command'
    },
    {
        id:    'Supply_Fan_Status',
        value: 'Supply Fan Status'
    }
]; 
